module.exports = __webpack_public_path__ + "img/fitness_thumbnail-600x450.38f23c33.jpg";